const MeshIOIndex = ['BYUMeshIO', 'FreeSurferAsciiMeshIO', 'FreeSurferBinaryMeshIO', 'OBJMeshIO', 'OFFMeshIO', 'STLMeshIO', 'SWCMeshIO', 'VTKPolyDataMeshIO', 'WASMMeshIO', 'WASMZstdMeshIO',];
export default MeshIOIndex;
